module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-open-f7f0bdf50541616e0b67ea9118495f81.png";